"use client";
import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import "@/components/Ads/ads.css";

// Billboard (66a9f16162db4b2934723c5d) - 728x90, 970x90, 970x250
export function Billboard({ isVisible = false }: { isVisible?: boolean }) {
  if (!isVisible) {
    return <div />;
  }
  return (
    <div
      className="vm-placement desktop-placement"
      data-id="66a9f16162db4b2934723c5d"
      // data-display-type="hybrid-banner"
    ></div>
  );
}

export function BillboardContainer({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return (
    <div
      className={`ad-container relative flex justify-center items-center w-full bg-slate-900/50 rounded-md`}
    >
      <div className="absolute text-slate-600 -z-10">Advertisement</div>
      {children}
    </div>
  );
}

// Mobile - MPU (66a9f5bea94e796ad91f6d6e) - 300x250, 336x280
export function Mobile({ isVisible = false }: { isVisible?: boolean }) {
  if (!isVisible) {
    return <div></div>;
  }
  return (
    <div
      className="vm-placement mobile-placement"
      data-id="66a9f5bea94e796ad91f6d6e"
      // data-display-type="hybrid-banner"
    ></div>
  );
}

// Rich Media (66a9f5d562db4b2934723c5f) - 1x1
export function RichMedia() {
  return (
    <div
      className="vm-placement"
      data-id="66a9f5d562db4b2934723c5f"
      style={{ display: "none" }}
    ></div>
  );
}

function debounce<T extends (...args: any[]) => void>(
  func: T,
  delay: number,
): T {
  let timeout: NodeJS.Timeout;
  return function (...args: Parameters<T>) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(null, args);
    }, delay);
  } as T;
}

export function VideoAd({ screen }: { screen: "desktop" | "mobile" }) {
  "use client";

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1250px)",
  });

  const [showVideoAd, setShowVideoAd] = useState(false);

  useEffect(() => {
    const handleResize = debounce(() => {
      const isDesktop: boolean = isDesktopOrLaptop;
      const isMobileView: boolean = !isDesktopOrLaptop;

      if (
        (screen === "desktop" && isDesktop) ||
        (screen === "mobile" && isMobileView)
      ) {
        setShowVideoAd(true);
      } else {
        setShowVideoAd(false);
      }
    }, 200); // Adjust debounce delay as needed

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [screen, isDesktopOrLaptop]);

  return (
    <div>
      {showVideoAd && (
        <div className="relative video-container bg-slate-900/50 rounded-tr-md rounded-br-md">
          <div className="vm-placement" id="vm-av" data-format="isvideo"></div>
        </div>
      )}
    </div>
  );
}
